
import React, { Fragment } from 'react';

import { useDispatch, useSelector } from "react-redux";

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import SignpostIcon from '@mui/icons-material/Signpost';
import LanguageIcon from '@mui/icons-material/Language';
import LocationCityIcon from '@mui/icons-material/LocationCity';

import { setFormDataAction } from 'redux/actions/getFormActions';
import GoogleAutoComplete from '../components/GoogleAutoComplete';

const Form2 = (props) => {

    const dispatch = useDispatch();
    const formData = useSelector(state => state.formData.data);

    const handleChange = (e, label) => {
      const value = e.target.value;
      dispatch(setFormDataAction({...formData, [label]: value}));
    }

    const handleAddress = (value) => {
      const { short_name: city = '' } =  value.address_components.find(c => c.types.includes("postal_town")) || {};
      const { short_name: streetNumber = '' } =  value.address_components.find(c => c.types.includes("street_number")) || {};
      const { short_name: route = '' } =  value.address_components.find(c => c.types.includes("route")) || {};
      const { long_name: postalCode = '' } =  value.address_components.find(c => c.types.includes('postal_code')) || {};
      dispatch(setFormDataAction({
        ...formData, 
        street1: (streetNumber + ' ' + route),
        city: city,
        zipCode: postalCode,
        termsCheck: false
      }));
    }


    const disable = 
    (formData.street1 && formData.zipCode && formData.city && formData.country) ? false : true;

  return (
    <Fragment >
      <Grid>
        <Grid container justifyContent='center' sx={{ mt: 2 }}>
          <Grid item xs={11} sm={10} md={7}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={2} sx={{mt: 2}}>
                <LanguageIcon sx={{fontSize: 37 }} color="primary"/>
              </Grid>
              <Grid item xs={9}>
                <Typography variant="body2" color="primary">Country</Typography>
                <TextField
                    error={!formData.country}
                    variant="standard"
                    color={formData.country ? "primary" : "error"}
                    required
                    fullWidth
                    value={formData.country}
                    onChange={(e) => handleChange(e, 'country')}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent='center' sx={{ mt: 1 }}>
          <Grid item xs={11} sm={10} md={7}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={2} sx={{mt: 2}}>
                <SignpostIcon sx={{fontSize: 37 }} color="primary"/>
              </Grid>
              <Grid item xs={9}>
                  <GoogleAutoComplete address1={formData.street1} handleAddress={(value) => handleAddress(value)} />
                  {/* <TextField
                      error={!formData.street1}
                      variant="standard"
                      color={formData.street1 ? "primary" : "error"}
                      required
                      fullWidth
                      value={formData.street1}
                      onChange={(e) => handleChange(e, 'street1')}
                  /> */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent='center' sx={{ mt: 1 }}>
          <Grid item xs={11} sm={10} md={7}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={2} sx={{mt: 2}}>
                <SignpostIcon sx={{fontSize: 37 }} color="primary"/>
              </Grid>
              <Grid item xs={9}>
                  <Typography variant="body2" color="primary">Street Address Line 2</Typography>
                  <TextField
                      variant="standard"
                      required
                      fullWidth
                      value={formData.street2}
                      onChange={(e) => handleChange(e, 'street2')}
                  />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent='center' sx={{ my: 1}} >
          <Grid item xs={11} sm={10} md={7}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={2} sx={{mt: 2}}>
                  <LocationCityIcon sx={{fontSize: 37 }} color="primary"/>
              </Grid>
              <Grid item xs={9}>
                <Typography variant="body2" color="primary">City</Typography>
                <TextField
                    error={!formData.city}
                    variant="standard"
                    color={formData.city ? "primary" : "error"}
                    required
                    fullWidth
                    value={formData.city}
                    onChange={(e) => handleChange(e, 'city')}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent='center' sx={{ my: 1}} >
          <Grid item xs={11} sm={10} md={7}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={2} sx={{mt: 2}}>
                  <LocationCityIcon sx={{fontSize: 37 }} color="primary"/>
              </Grid>
              <Grid item xs={9}>
                <Typography variant="body2" color="primary">Postal/ZipCode</Typography>
                <TextField
                    error={!formData.zipCode}
                    variant="standard"
                    color={formData.zipCode ? "primary" : "error"}
                    required
                    fullWidth
                    value={formData.zipCode}
                    onChange={(e) => handleChange(e, 'zipCode')}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', my: 3 }}>
            <Button 
              onClick={() => props.handleBack()} 
              variant="contained" 
              sx={{mx:1}}
            >
                <Typography> Back </Typography>
            </Button>
            <Button 
              onClick={() => props.handleNext()} 
              variant="contained" 
              disabled={disable}
              sx={{mx:1}}
            >
                <Typography> Next </Typography>
            </Button>
        </Box>
    </Fragment>
  );
}
  
export default Form2;
